// extracted by mini-css-extract-plugin
export default {"container":"style_container__vzN8q","pending":"style_pending__ewAgV","pendingIcon":"style_pendingIcon__hJpWo"};